"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function QuestionEmail24Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id1 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id2 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 30, height: 24, viewBox: "0 0 30 24" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `questionemail24-${id0}`, d: "M0 2.005C0 .898.898 0 1.992 0h26.016C29.108 0 30 .897 30 2.005v19.99C30 23.102 29.102 24 28.008 24H1.992C.892 24 0 23.103 0 21.995V2.005z" }),
            react_1.default.createElement("path", { id: `questionemail24-${id1}`, d: "M24.526 5v13.474H6V5h18.526zm-1.684 3.536l-7.579 5.306-7.579-5.306v8.253h15.158V8.536zm-.361-1.852H8.045l7.218 5.053 7.218-5.053z" }),
            react_1.default.createElement("filter", { id: `questionemail24-${id2}`, width: "140%", height: "150%", x: "-20%", y: "-25%", filterUnits: "objectBoundingBox" },
                react_1.default.createElement("feOffset", { in: "SourceAlpha", result: "shadowOffsetOuter1" }),
                react_1.default.createElement("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: 2 }),
                react_1.default.createElement("feColorMatrix", { in: "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0.0705882353 0 0 0 0 0.278431373 0 0 0 0.1 0" }))),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("use", { fill: "#000", filter: `url(#questionemail24-${id2})`, xlinkHref: `#questionemail24-${id0}` }),
            react_1.default.createElement("use", { fill: "#FFF", xlinkHref: `#questionemail24-${id0}` }),
            react_1.default.createElement("rect", { width: 24, height: 10, x: 3, y: 7, fill: "#CDD8FF", fillRule: "nonzero", rx: 1 }),
            react_1.default.createElement("use", { fill: "#698AFF", fillRule: "nonzero", transform: "matrix(-1 0 0 1 30.526 0)", xlinkHref: `#questionemail24-${id1}` })));
}
function QuestionEmail24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(QuestionEmail24Svg, Object.assign({}, svgProps)));
}
exports.default = QuestionEmail24;
//# sourceMappingURL=QuestionEmail24.js.map